import React from 'react';
import { Snackbar, Alert } from '@mui/material';

type AlertType = 'success' | 'error' | 'info' | 'warning';

interface AlertMessageProps {
  open: boolean;
  type: AlertType;
  message: string;
  onClose: () => void;
  autoHideDuration?: number;
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  open,
  type,
  message,
  onClose,
  autoHideDuration = 6000,
}) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
    >
      <Alert onClose={onClose} severity={type} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertMessage;
